/*!
 * numeral.js language configuration
 * language : German in Switzerland (de-ch)
 */
import type numeral from 'numeral';

export const language: numeral.NumeralJSLocale = {
    delimiters: {
        thousands: "'",
        decimal: '.',
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't',
    },
    currency: {
        symbol: 'CHF',
    },
    ordinal: (_number: number): string => {
        return '.';
    },
};
